import useSlideOver from '../../../useSlideOver';
import UseContext from '../../../../../hooks/useContext';
import SlideOverHeader from '../../../component/header';
import SlideOverBody from '../../../component/body';
import AdminMissionDetails from '../../../../../pages/pages/mission/adminMissionDetails';
import { useState, useEffect } from 'react';

const SlideOverMission = () => {
  const { objID, missionInitialPage, setMissionInitialPage } = UseContext();
  const { toggleSlideOver } = useSlideOver();
  const [searchMissionResult, setSearchMissionResult] = useState([]);

  // Réinitialiser missionInitialPage après l'avoir utilisé
  useEffect(() => {
    if (missionInitialPage !== undefined) {
      setMissionInitialPage(undefined);
    }
  }, [objID]);

  const closeSlideOver = () => {
    toggleSlideOver('');
    setMissionInitialPage(undefined);
  };

  return (
    <>
      <SlideOverHeader hide={closeSlideOver} hideShow={true}>
        Détails de la mission
      </SlideOverHeader>
      <SlideOverBody>
        {objID ? (
          <AdminMissionDetails
            missionId={objID}
            searchMissionResult={searchMissionResult}
            setSearchMissionResult={setSearchMissionResult}
            initialPage={missionInitialPage}
          />
        ) : (
          <div className="p-4 text-gray-500">Aucune mission sélectionnée</div>
        )}
      </SlideOverBody>
    </>
  );
};

export default SlideOverMission;

